function renderInline(text, keyPrefix) {
  return text
    .split(/(\*\*[^*]+\*\*|\*[^*]+\*|`[^`]+`)/g)
    .filter(Boolean)
    .map((token, index) => {
      const key = `${keyPrefix}-${index}`;

      if (token.startsWith('**') && token.endsWith('**')) {
        return (
          <strong key={key} className="font-medium text-slate-900">
            {token.slice(2, -2)}
          </strong>
        );
      }

      if (token.startsWith('*') && token.endsWith('*')) {
        return (
          <em key={key} className="italic text-slate-800">
            {token.slice(1, -1)}
          </em>
        );
      }

      if (token.startsWith('`') && token.endsWith('`')) {
        return (
          <code key={key} className="rounded bg-slate-100 px-1.5 py-0.5 font-mono text-sm text-slate-900">
            {token.slice(1, -1)}
          </code>
        );
      }

      return token;
    });
}

export default function RichText({ content, className = '' }) {
  const paragraphs = content
    .split(/\n{2,}/)
    .map((paragraph) => paragraph.trim())
    .filter(Boolean);

  if (paragraphs.length === 0) {
    return null;
  }

  return (
    <div className={className}>
      {paragraphs.map((paragraph, paragraphIndex) => {
        const lines = paragraph.split('\n');
        const children = [];

        lines.forEach((line, lineIndex) => {
          children.push(...renderInline(line, `${paragraphIndex}-${lineIndex}`));

          if (lineIndex < lines.length - 1) {
            children.push(<br key={`${paragraphIndex}-${lineIndex}-break`} />);
          }
        });

        return (
          <p key={`paragraph-${paragraphIndex}`} className="mb-5 text-[15px] leading-8 text-slate-700 last:mb-0">
            {children}
          </p>
        );
      })}
    </div>
  );
}
